export default {
    name: 'MenuStepBase',
    inject: ['eventBus'],
    mounted() {
        this.eventBus.$on('onNextEvent', this.handleOnNextEvent);
        this.eventBus.$on('onBackEvent', this.handleOnBackEvent);
    },
    destroyed() {
        this.eventBus.$off('onNextEvent', this.handleOnNextEvent);
        this.eventBus.$off('onBackEvent', this.handleOnBackEvent);
    }   

}